import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonGroup } from '@gemini/ui';
import { serpViewIconMap, serpViewPaths } from '../../helpers/constants';
import { getQueryString } from '../../helpers/getQueryString/getQueryString';
import { useSerpTranslation } from '../../hooks/useI18n';
import { mapListButtonTrackingMedium } from '../../tracking/helpers';
export const SerpMapListButtonGroupTestId = 'serp-map-list-button-group-test-id';
export const MapMapListButtonGroupTestId = 'map-map-list-button-group-test-id';
export const MapListButtonGroup = ({ view, searchModel, order, page, defaultOrder }) => {
    const { t } = useSerpTranslation();
    const items = ['list', 'map'].map((value) => ({
        label: t(`header.quick_access.${value}`),
        value,
        icon: serpViewIconMap[value],
    }));
    const next = view === 'map' ? 'list' : 'map';
    return (_jsx(ButtonGroup, { label: view === 'map' ? 'Map to list' : 'List to map', testId: view === 'map' ? MapMapListButtonGroupTestId : SerpMapListButtonGroupTestId, name: "never", items: items, value: view, iconPosition: "start", onChange: () => {
            window.location.href = `/${serpViewPaths[next]}?${getQueryString({ searchModel, order, page, trackingMedium: mapListButtonTrackingMedium[next] }, defaultOrder)}`;
        } }));
};
